//TODO : Refactor after ai
import { Children } from "react";
import type { HTMLAttributes, ReactNode } from "react";

export interface ObjectListCardProps extends Omit<HTMLAttributes<HTMLElement>, "title"> {
  title?: ReactNode;
  /** The TRUE total, even when only the first few rows render. */
  count?: number;
  actions?: ReactNode;
  children?: ReactNode;
  footer?: ReactNode;
  empty?: ReactNode;
}

/** A named collection of objects — one x:n relation of the record you are on. */
export function ObjectListCard({
  title,
  count,
  actions,
  children,
  footer,
  empty,
  className = "",
  ...rest
}: ObjectListCardProps) {
  const isEmpty = Children.toArray(children).length === 0;

  return (
    <section className={`bui-obj-list ${className}`} {...rest}>
      <div className="bui-obj-list__head">
        {title && <h2 className="bui-obj-list__title">{title}</h2>}
        {count != null && <span className="bui-obj-list__count">{count}</span>}
        {actions && <div className="bui-obj-list__actions">{actions}</div>}
      </div>
      {isEmpty && empty ? (
        <div className="bui-obj-list__empty">{empty}</div>
      ) : (
        <div className="bui-obj-list__body">{children}</div>
      )}
      {footer && <div className="bui-obj-list__foot">{footer}</div>}
    </section>
  );
}
